import { AlarmBehaviorDto, AlarmDetailsDto } from '.';

export function isAcknowledged(alarm: AlarmDetailsDto) : boolean {
    return alarm.alarmClass.onBehavior.ackNecessary ? (alarm.ackTime === null ? false : true) : true;
}

export function needsAcknowledge(alarm: AlarmDetailsDto) : boolean {
    return alarm.alarmClass.onBehavior.ackNecessary;
}

export function sort(a: AlarmDetailsDto, b: AlarmDetailsDto) : number {
    if (!a.ackTime && b.ackTime)
        return -1;
    if (!b.ackTime && a.ackTime)
        return 1;
    if (!a.ackTime && !b.ackTime)
        return (b.onTime > a.onTime) ? 1 : -1;
    if (a.ackTime && b.ackTime)
        return (b.onTime > a.onTime) ? 1 : -1;
    return 1;
}
   
export function getBehavior(alarm: AlarmDetailsDto) : AlarmBehaviorDto {
    return alarm.ackTime ? alarm.alarmClass.ackedBehavior : (alarm.offTime ? alarm.alarmClass.offBehavior : alarm.alarmClass.onBehavior);
}

